import { useAppSelector } from "../../../app/store";
import Loader from "../../../components/ui/Loader";
import { useGetDashboardDataQuery } from "../../../features/organization/dashboard/dashboardApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";
import Summery from "./_components/Summery";
import UserProfile from "./_components/UserProfile";

export default function Dashboard() {
  const { user } = useAppSelector((state) => state.auth);
  const { isError, isLoading, error, data } = useGetDashboardDataQuery({
    params: {
      business_id: user?.business_id,
    },
  });
  useError(isError, error, "Dashboard data get fail");

  const dashboardData = data?.data;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <SidebarLayout title="Dashboard">
      <UserProfile data={dashboardData} />
      <Summery data={dashboardData} />
    </SidebarLayout>
  );
}
